import { httpClientErrorSrc176Evid404 } from '@wix/error-handler-core/@wix/bi-logger-os-data/v2';
import { withoutDefaults } from '../util/withoutDefaults';
export function reportErrorBi(errorHandler, params) {
  var _webWindow$location;
  const {
    errorAccessor,
    requestOptions
  } = params;
  const {
    biLogger,
    onlineManager,
    webWindow,
    environment,
    biDefaultsOverrides
  } = errorHandler;
  const {
    statusCode,
    errorData,
    errorDetails,
    errorMessage,
    exceptionMessage,
    httpError,
    error
  } = errorAccessor;
  const config = httpError == null ? void 0 : httpError.config;
  biLogger.report(withoutDefaults(httpClientErrorSrc176Evid404)({
    artifact_id: environment.artifactId,
    full_artifact_id: environment.fullArtifactId,
    hostingEnvironment: biDefaultsOverrides == null ? void 0 : biDefaultsOverrides.hostingEnvironment,
    app_id: biDefaultsOverrides == null ? void 0 : biDefaultsOverrides.app_id,
    artifactVersion: environment.version,
    error_code: statusCode,
    error_json: errorData ? JSON.stringify(errorData) : undefined,
    exception_message: exceptionMessage,
    error_message: errorMessage,
    client_error_code: errorAccessor == null ? void 0 : errorAccessor.clientCode,
    error_type: errorDetails != null && errorDetails.applicationError ? 'applicationError' : errorDetails != null && errorDetails.validationError ? 'validationError' : undefined,
    request_id: httpError == null ? void 0 : httpError.requestId,
    hasInternetConnection: onlineManager.onLine,
    pageUrl: webWindow == null || (_webWindow$location = webWindow.location) == null ? void 0 : _webWindow$location.href,
    session_id: error == null ? void 0 : error._errorHandlerSessionId,
    serverUrl: (config == null ? void 0 : config.url) || (requestOptions == null ? void 0 : requestOptions.url),
    method: (config == null ? void 0 : config.method) || (requestOptions == null ? void 0 : requestOptions.method) || 'unknown',
    entity_fqdn: config == null ? void 0 : config.entityFqdn,
    method_fqn: config == null ? void 0 : config.methodFqn,
    server_artifactid: config == null ? void 0 : config.artifactId
  }));
}
//# sourceMappingURL=reportErrorBi.js.map